import CopyController from "csi/action/CopyController";
import dojoDeclare from "dojo/_base/declare";
import NewMixin from "./NewMixin";


const Copy = dojoDeclare([CopyController, NewMixin], {

	getNewNodes() {
		// summary: get nodes resulting from action for postprocessing
		return this.getMovedNodes();
	},

	preProcess() {
		// summary: call mixin before continuing
		if (this._newPreProcess()) {
			this.inherited(arguments);
		}
	},

	/**
	 * Call mixin if no other post processing action
	 */
	postProcessSuccess() {
		// C8-25516; this._newPostProcess(true) - argument "true" means that we do INSERT operation, This is bInsert flag
		// if flag bInsert is true - row will be inserted according to this.refNode and this.refNodeNext values
		// if flag bInsert is false - row might be inserted in different position, including end of table
		return this.inherited(arguments) || this._newPostProcess(true);
	},
});

export = Copy;